import { ConversationMemberView, ConversationParticipantView } from '@mark43/cad-api';
import { GroupBase } from '@cad-arc';
import { ConversationParticipantTypesMap } from '../../store/types';
import { SEND_AS_OPTION_CATEGORIES } from './constants';
import { SendAsOption } from './types';

export function convertSendAsOptionToMemberView(
    sendAsOption: SendAsOption
): ConversationMemberView {
    return {
        ...sendAsOption,
        id: sendAsOption.value,
    };
}

export function convertSendAsOptionToParticipantView(
    sendAsOption: SendAsOption
): ConversationParticipantView {
    return {
        ...sendAsOption,
        id: sendAsOption.value,
    };
}

export function convertParticipantViewToSendAsOption(
    conversationParticipantView: ConversationParticipantView
): SendAsOption {
    return {
        ...conversationParticipantView,
        value: conversationParticipantView.id,
    };
}

export function getUniqueMembers(members: ConversationMemberView[]) {
    const memberByKey: Record<string, ConversationMemberView> = {};
    const uniqueMembers: ConversationMemberView[] = [];
    for (const member of members) {
        const key = `${member.entityType}-${member.id}`;
        if (!memberByKey[key]) {
            memberByKey[key] = member;
            uniqueMembers.push(member);
        }
    }
    return uniqueMembers;
}

export function getSendAsOptions(
    participantByType?: ConversationParticipantTypesMap,
    sendMessagesAsIndividual?: boolean
): GroupBase<SendAsOption>[] {
    if (!participantByType) {
        return [];
    }

    const sendAsOptions: GroupBase<SendAsOption>[] = [];
    for (const category of SEND_AS_OPTION_CATEGORIES) {
        const categoryOptions: SendAsOption[] = [];
        for (const entityType of category.entityTypes) {
            if (entityType === 'USER' && !sendMessagesAsIndividual) {
                continue;
            }
            const participant = participantByType[entityType];
            const categoryParticipants = Array.isArray(participant)
                ? participant
                : participant
                ? [participant]
                : [];
            if (categoryParticipants.length) {
                categoryOptions.push(
                    ...categoryParticipants.map(convertParticipantViewToSendAsOption)
                );
            }
        }
        if (categoryOptions.length) {
            sendAsOptions.push({
                label: category.category,
                options: categoryOptions,
            });
        }
    }
    return sendAsOptions;
}
